import LoginSocialBase from './Base.jsx';

class LoginSocialTwitter extends LoginSocialBase {

  constructor(...args) {
    super('twitter', ...args);
  }

  init() {
    this.enableButton();
    this.$button.on('click', (e) => {
      e.preventDefault();
      this.loginWithSocial();
    });

    const userId = $('.c-loginModal__twitterUserId').val();
    if (userId) {
      this.testUserID(userId);
    }
  }

  async loginWithSocial() {
    const { ajax_url, nonce_ajax, service } = this;

    this.startLoading();

    const {value = false, message = '', errors = []} = await $.post({
      url: ajax_url,
      dataType: 'json',
      data: {
        action: 'lrg_member_login_social',
        service,
        nonce_ajax,
      },
    }).always(this.stopLoading);

    this.stopLoading();
    this.handleErrors(errors);

    const [,redirect] = message.match(/^redirect:(.*)/) || [];

    if(redirect) {
      window.location = redirect;
    }

    this.maybeReload(value)
  }
}

export default LoginSocialTwitter;
